export default [

	// 电子智能秤
	{
		path: '/equipment/dzc',
		name: '电子智能秤',
		meta: {
			title: '电子智能秤',
			// icon: require('@/assets/images/general/search.png'),
			title2: '电子智能秤-华略未来科技',
			icon: "icon-zu405-06"
		},
		component: () => import('views/equipment/dzc/index.vue'),
	},
	// 晨检仪
	{
		path: '/equipment/cjy',
		name: '晨检仪',
		meta: {
			title: '晨检仪',
			title2: '晨检仪-华略未来科技',
			icon: "icon-zu405-07"
		},
		component: () => import('views/equipment/cjy/index.vue'),
	},
	// AI视觉分析
	{
		path: '/equipment/sjfx',
		name: 'AI视觉分析',
		meta: {
			title: 'AI视觉分析',
			title2: 'AI视觉分析-华略未来科技',
			icon: "icon-zu405-08"
		},
		component: () => import('views/equipment/sjfx/index.vue'),
	},
	// 智能留样柜
	{
		path: '/equipment/znlyg',
		name: '智能留样柜',
		meta: {
			title: '智能留样柜',
			title2: '智能留样柜-华略未来科技',
			icon: "icon-zu405-09"
		},
		component: () => import('views/equipment/znlyg/index.vue'),
	},
	// 农产快检仪
	{
		path: '/equipment/nckjy',
		name: '农产快检仪',
		meta: {
			title: '农产快检仪',
			title2: '农产快检仪-华略未来科技',
			icon: "icon-zu405-10"
		},
        component: () => import('views/equipment/nckjy/index.vue'),
	},
	// 信息公示屏
	{
		path: '/equipment/xxgsp',
		name: '信息公示屏',
		meta: {
			title: '信息公示屏',
			title2: '信息公示屏-华略未来科技',
			icon: "icon-zu405-11"
		},
        component: () => import('views/equipment/xxgsp/index.vue'),
	},

];

